import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import ReplaceDevice
  from '@app/components/MyDevices/DeviceInfo/DeviceSettings/GeneralSettings/AdvancedSettings/zwave/FailedNode/ReplaceDevice/ReplaceDevice'
import { withAccessDenied, withNotifications } from '@app/hocs'
import isAccessTokenValid from '@app/helpers/isAccessTokenValid'
import isUserLoggedIn from '@app/helpers/isUserLoggedIn'
// @ts-ignore
import * as syncNotifications from '@app/actions/notifications/notificationsChannel'
import { AppState } from '@app/@types/store'
import { AppDispatch } from '@app/store'

let enhance = ReplaceDevice

const mapStateToProps = (state: AppState) => {
  const { status } = state.myDevices.failedNode
  const { isMobile } = state.mobileDetector
  return {
    status,
    isMobile,
    accessToken: state.secrets.accessToken && state.secrets.accessToken.token,
    accessDenied: !isAccessTokenValid(state.secrets.accessToken),
    userLoggedIn: (isUserLoggedIn(state.users.currentUser.user.preferredName)),
  }
}

const mapDispatchToProps = (dispatch: AppDispatch) => bindActionCreators({
  notifications: syncNotifications.sync,
}, dispatch)

enhance = withAccessDenied(enhance)
enhance = withNotifications(enhance)
// @ts-ignore
enhance = connect(mapStateToProps, mapDispatchToProps)(enhance)

const ReplaceDeviceEnhanced = enhance

export default ReplaceDeviceEnhanced
